import { RemittanceItemModel, RemittanceAdjustmentModel, RemittancePaymentModel, RemittanceStatisticsModel, RemittanceModel } from "./";

export class RemittanceSummaryModel {
    Remittance: RemittanceModel;
    RemittanceItems: RemittanceItemModel[];
    RemittancePayments: RemittancePaymentModel[];
    RemittanceAdjustments: RemittanceAdjustmentModel[];
    Statistics: RemittanceStatisticsModel;
}